// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"f5089e0a","80":"ea046fa5","597":"9dbca794"}[chunkId] + ".chunk.js";
};